// SkeletonLoader.jsx

import React from 'react';
import { Skeleton } from '../shadcn/ui/skeleton';

const SkeletonLoader = () => {
    return (
        <div>
            {[...Array(5)].map((_, index) => (
                <div key={index} className="flex items-center space-x-4 mb-4">
                    <Skeleton className="h-6 w-14" />
                    <Skeleton className="w-14 h-14" />
                    <div className="flex-1">
                        <Skeleton className="h-4 w-3/4 mb-2" />
                        <Skeleton className="h-3 w-1/2 mb-1" />
                        <Skeleton className="h-3 w-1/4" />
                    </div>
                    <Skeleton className="h-7 w-8" />
                    <Skeleton className="h-7 w-8" />
                </div>
            ))}
        </div>
    );
};

export default SkeletonLoader;
